import { useCartStore } from "~/stores/cart";

export default defineNuxtRouteMiddleware((to, from) => {
    const cartStore = useCartStore();
    cartStore.initialize();

    const allowedPaths = ['/checkout', '/payment/response/failed', '/payment/response/success'];

    if (cartStore.totalItem <= 0 && !allowedPaths.includes(to.path)) {
        return navigateTo('/cart');
    }
});